<template>
  <div class="tags-section-card">
    <div class="tags-section-card__content">
      <TagsForm
        ref="tagsForm"
        :definitions="definitions"
        :tags="tags"
        @change="handleChange"
      />
    </div>
     <div class="tags-section-card__footer">
      <CButton
        :color="isDirty ? 'primary' : 'secondary'"
        :disabled="!isDirty"
        @click="handleSave"
      >
        <translate translate-context="photoarchive.action">Save changes</translate>
      </CButton>
    </div>
  </div>

</template>

<script>
import TagsForm from './TagsForm.vue'

export default {
  name: "TagsSectionCard",
  components: {
    TagsForm
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    definitions: {
      type: Array,
      required: true
    },
    tags: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isDirty: false,
      localTags: {}
    }
  },
  methods: {
    handleChange(tags) {
      this.localTags = tags
      this.isDirty = true
    },
    handleSave() {
      if (this.$refs.tagsForm && !this.$refs.tagsForm.validate()) {
        return
      }
      const tagsData = this.$refs.tagsForm ? this.$refs.tagsForm.getData() : {}
      this.$emit('save', tagsData)
      this.isDirty = false
    },
    hasPendingChanges() {
      return this.isDirty
    },
    resetDirty() {
      this.isDirty = false
    }
  }
}
</script>


